module.exports = __webpack_public_path__ + "img/illust-oji-play.1c6b22b6.gif";